// extracted by mini-css-extract-plugin
module.exports = {"Sidebar":"sidebar_Sidebar__INEmf","Content":"sidebar_Content__rbK6K"};